<template>
  <v-row justify="center">
    <v-dialog v-model="show" persistent max-width="600px">
      <custom-modal
        title="Supplier List "
        @onSubmit="saveBrand"
        :showSave="false"
        @onClose="show = false"
        :isLoading="isLoading"
      >
        <v-col cols="12 py-0">
          <v-card>
            <!-- <v-container fluid> -->
            <!-- Filters -->
            <v-row class="ma-0 align-right">
              <v-col cols="12" sm="12" lg="12" md="12" class=""> </v-col>
              <v-col
                cols="12"
                sm="6"
                lg="6"
                md="6"
                class="px-0 d-flex justify-space-between"
              >
                <v-combobox
                  hide-details="auto"
                  hide-no-data
                  v-model="selectedSupplier"
                  @change="searchSuppliers = ''"
                  @input="GetSuppliers(searchSuppliers)"
                  :items="suppliers"
                  clearable
                  :search-input.sync="searchSuppliers"
                  outlined
                  item-text="name"
                  item-value="id"
                  label="Select Suppliers"
                  multiple
                  small-chips
                >
                </v-combobox>
                <v-btn
                  depressed
                  small
                  height="32"
                  class="btn_blue w-100 ml-2"
                  @click="AssignSupplierToProduct()"
                >
                  update
                </v-btn>
              </v-col>
            </v-row>

            <!-- <v-row class="ma-0 align-right sub-section"> -->
            <!-- <TableFilters
                  :filters="['search']"
                  v-model="filter"
                  :columns="columns"
                ></TableFilters> -->
            <!-- </v-row> -->
            <v-row>
              <v-col cols="12">
                <v-data-table
                  :items-per-page="paginationOptions.perPage"
                  :headers="columns"
                  :items="ProductSuppliers"
                  item-key="id"
                  hide-default-footer
                >
                  <!-- No -->
                  <template v-slot:item.no>
                    <v-icon>mdi-vuetify</v-icon>
                  </template>

                  <!-- Action -->
                  <template v-slot:item.action="{ item }">
                    <span @click="openConfirmation(item)">
                      <v-icon v-bind="attrs" v-on="on">mdi-delete</v-icon>
                    </span>
                  </template>
                  <template v-slot:item.name="{ item }">
                    <v-avatar size="32px" item color="primary">
                      <span class="white--text subtitle-2 text-uppercase">
                        {{ item.name.substring(0, 2) }}</span
                      >
                    </v-avatar>
                    <b>
                      {{ item.name }}
                    </b>
                  </template>
                </v-data-table>
                <paginationComponent
                  @paginationOptions="setPaginationOptions"
                  :url="`products/${Prdid}/suppliers`"
                  @response="receiveSuppliersResponse"
                  ref="supplierdetails"
                  :filter="filter"
                />
              </v-col>
            </v-row>
            <!-- </v-container> -->
          </v-card>
        </v-col>
      </custom-modal>
    </v-dialog>
  </v-row>
</template>
<script>
import confirmation from '../../shared/components/confirmation';
import TableFilters from '@/components/base/TableFilters';
import paginationComponent from '../../shared/components/pagination.vue';

import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from 'vee-validate';

extend('min', (value) => {
  if (value.length >= 3) {
    return true;
  }
  return 'Please enter above three characters';
});

export default {
  data: () => ({
    show: false,
    value: [],
    options: [],
    paginationOptions: {},
    searchSuppliers: null,
    selectedSupplier: [],
    suppliers: [],
    ProductSuppliers: [],
    productDetails: [],
    isLoading: false,
    paginationOptions: {},
    columns: [
      {
        text: 'Name',
        value: 'name',
        show: true,
        disabled: false,
        align: 'center',
      },

      {
        text: 'Actions',
        value: 'action',
        show: true,
        disabled: false,
        align: 'center',
      },
    ],
    filter: {
      search: '',
    },
  }),

  name: 'SupplierList',
  props: {
    visible: {
      type: Boolean,
      default: true,
    },
    data: {
      type: Object,
      default: {},
    },
    Prdid: {
      type: String,
      default: 1,
    },
  },
  components: { paginationComponent, TableFilters },
  watch: {
    searchSuppliers(value) {
      if (!value) {
        return;
      }
      this.GetSuppliers(value);
    },
  },
  methods: {
    receiveSuppliersResponse(supplierData) {
      this.ProductSuppliers = supplierData;
      this.GetSuppliers();
    },
    openConfirmation(item) {
      confirmation.dialog = true;

      this.$confirm('Do you want to Remove ?').then((res) => {
        if (res) {
          this.removeSupplier(item);
        }
      });
    },
    async removeSupplier(item) {
      const credentials = new Object();
      credentials.suppliers = [item.id];
      credentials.productId = this.Prdid;

      this.removeSupplierFromProduct(credentials);
    },

    removeSupplierFromProduct(credentials) {
      this.$store
        .dispatch(`product/RemoveSupplierFromProduct`, credentials)
        .then((res) => {
          this.refreshData();

          let index = this.ProductSuppliers.findIndex(
            (p) => p.id == credentials.suppliers[0],
          );
          if (index != -1) {
            this.ProductSuppliers.splice(index, 1);
          }
          this.selectedSupplier = [];
          this.GetSuppliers();

          this.isLoading = false;
          this.$toast.success('Supplier removed successfully');
        })
        .catch((err) => {
          this.isLoading = false;
          this.$toast.error('Failed to remove supplier.');
        });
    },

    GetSuppliers(query = '') {
      this.searchSuppliers = null;
      let except = [];
      this.ProductSuppliers.forEach((supplier) => {
        except.push(supplier.id);
      });
      if (this.selectedSupplier.length > 0) {
        this.selectedSupplier.forEach((supplier) => {
          except.push(supplier.id);
        });
      }
      this.$store
        .dispatch('supplier/GetSupplierSearch', {
          query: query,
          except: except,
          status: 'active',
        })
        .then((res) => {
          this.suppliers = res;
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.messages = err.data.title;
        });
    },
    refreshData() {
      this.$refs.supplierdetails.refreshData();
    },
    async AssignSupplierToProduct() {
      let credentials = new Object();
      credentials.suppliers = [];
      this.selectedSupplier.map((p) => {
        credentials.suppliers.push(p.id);
      });
      credentials.productId = this.Prdid;
      this.AssignProduct(credentials);
    },
    AssignProduct(credentials) {
      this.$store
        .dispatch(`product/AssignSupplierToProducts`, credentials)
        .then((res) => {
          this.refreshData();
          this.selectedSupplier = null;
          this.isLoading = false;
          this.$toast.success('Supplier assigned successfully');

          //   this.$refs.supplierdetails[0].refreshData();
        })
        .catch((err) => {
          this.isLoading = false;
          this.$toast.error('Failed to assign suppiler');
          this.payment = new Payment();
        });
    },
    openModal() {
      this.show = true;
    },
  },
};
</script>
